

























































import { Component, Vue, Watch } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import CampaignBrowseContacts from '@/components/CampaignContacts/CampaignBrowseContacts.vue';
import CampaignContacts from '@/components/CampaignContacts/CampaignContacts.vue';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignContactStatus from '@/models/CampaignContacts/CampaignContactStatus';

@Component({
  name: 'CampaignContactsTab',
  components: { Alert, CampaignBrowseContacts, CampaignContacts }}
  )
export default class extends GiganautVue {

    campaignContactStatus = CampaignContactStatus;
    currentTabIndex = -1;

    async beforeMount() {
		//await CampaignDetailsModule.getContactSearchOptions();
		await CampaignDetailsModule.getCampaignContacts();
		await CampaignDetailsModule.browseDefaultContactSearch()
        if (this.campaignContacts.length > 0) {
            this.currentTabIndex = 1;
        }
	}

    get loading() {
        return CampaignDetailsModule.loadingContacts;
    }

	get currentCampaign() {
		return CampaignDetailsModule.currentCampaign;
    }

    // get tab() {
    //     return CampaignDetailsModule.campaignContactsVM.currentTabIndex;
    // }

    // set tab(tabIndex: number) {
    //     CampaignDetailsModule.campaignContactsVM.currentTabIndex = tabIndex;
    // }

    get campaignContacts() {
        return CampaignDetailsModule.campaignContactsVM.campaignContacts;
    }

    get isLoading() {
        return CampaignDetailsModule.loadingContacts;
    }
}
